import Chance from 'chance';
import Debug from 'debug';
import { ReportHelper } from '../report/index.js';
import { SampleHelper } from '../sample-data';
import formatter from '@knack/formatter';
import moment from 'moment-timezone';
const chance = new Chance();
const debug = Debug(`knack.core.helpers.reports.ReportSampleDataHelper`);
const chanceNumericConfiguration = {
    min: 0,
    max: 100,
    fixed: 1
};
const chanceColumnHeaderCount = {
    min: 5,
    max: 20
};
export const generateSampleDataForReport = (req, field) => {
    const report = req.report;
    let reportIndex = 0;
    const reportOutput = [];
    let formattedTrue;
    let formattedFalse;
    // TODO: when should old filters here be set?
    const old_filters = [
        []
    ];
    for (const group of report.groups) {
        let groupColumnHeaders = [];
        switch (group.type) {
            case `multiple_choice`:
                ReportHelper.processMultipleChoiceGroup(group, old_filters, field, report);
                groupColumnHeaders = req.report.filter_groups[req.report.filter_groups.length - 1];
                break;
            case `boolean`:
                formattedTrue = formatter.valueFormatter.formatValue({}, field, true, `text`, {});
                formattedFalse = formatter.valueFormatter.formatValue({}, field, false, `text`, {});
                groupColumnHeaders = [];
                groupColumnHeaders.push(formattedTrue);
                groupColumnHeaders.push(formattedFalse);
                ReportHelper.processBooleanGroup(group, old_filters, field, report, formattedTrue, formattedFalse);
                break;
            case `connection`:
                req.application = {
                    getField: (fieldKey) => {
                        return field;
                    },
                    getObject: (objectKey) => {
                        return {
                            getIdentifier: () => {
                                return `fakeFieldKey`;
                            }
                        };
                    }
                };
                group.connection_records = [];
                const fakeFields = {
                    fakeFieldKey: {
                        fieldType: `short_text`,
                        fieldFormat: {}
                    }
                };
                for (let groupColumnHeaderIndex = 0; groupColumnHeaderIndex < chance.integer(chanceColumnHeaderCount); groupColumnHeaderIndex++) {
                    const fakeRecord = {
                        values: SampleHelper.getSampleRecord(fakeFields, [
                            `fakeFieldKey`
                        ])
                    };
                    groupColumnHeaders.push(fakeRecord.values.fakeFieldKey);
                    group.connection_records.push(fakeRecord);
                }
                ReportHelper.processConnectionGroup(group, old_filters, field, req);
                break;
            case `date_time`:
                ReportHelper.processSQLDateTimeGroup(group, old_filters, field, new Date(), report, new moment());
                groupColumnHeaders = req.report.filter_groups[req.report.filter_groups.length - 1];
                break;
            default:
                for (let groupColumnHeaderIndex = 0; groupColumnHeaderIndex < chance.integer(chanceColumnHeaderCount); groupColumnHeaderIndex++) {
                    groupColumnHeaders.push(chance.word());
                }
                ReportHelper.handleProcessReportGroupResults(req, old_filters, groupColumnHeaders, field, group);
                break;
        }
        const reportGroup = {
            records: [],
            filters: [
                []
            ],
            summaries: []
        };
        // TODO investigate more complicated use cases. can this array be longer than 1 item? when?
        reportGroup.filters = [
            req.report.filter_groups[req.report.filter_groups.length - 1]
        ];
        // TODO: can we do this inline with the group generation, or do we need to wait until all groups are generated?
        for (const val of groupColumnHeaders) {
            const calculatedRecordValue = {};
            calculatedRecordValue[`group_${reportIndex}`] = val;
            calculatedRecordValue[`calc_${reportIndex}`] = chance.floating(chanceNumericConfiguration);
            reportGroup.records.push(calculatedRecordValue);
        }
        reportOutput.push(reportGroup);
        reportIndex++;
    }
    return reportOutput;
};
